import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, CommunicationConfigService } from '@argalis-apps/angular-global';
import { MDomain } from '@argalis-apps/models';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private configService: ConfigService,
    private http: HttpClient
  ) {}

  get(): Observable<MDomain.IDomain[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of([
        {
          id: 1,
          libelle: 'mon domaine avec enfants',
          type: 'domain',
          children: [
            { id: 3, libelle: 'ma famille enfant seule', type: 'famille', children: [] },
            {
              id: 4,
              libelle: 'ma famille enfant avec enfants',
              type: 'famille',
              children: [{ id: 2, libelle: 'mon secteur enfant', type: 'secteur', children: [] }]
            }
          ]
        },
        { id: 2, libelle: 'mon domaine seul', type: 'domain', children: [] },
        {
          id: 1,
          libelle: 'ma famille sans parent',
          type: 'famille',
          children: [
            { id: 3, libelle: 'mon secteur hors domain', type: 'secteur', children: [] },
            { id: 4, libelle: 'mon second secteur hors domain', type: 'secteur', children: [] }
          ]
        },
        { id: 2, libelle: 'ma famille seule', type: 'famille', children: [] },
        { id: 1, libelle: 'mon secteur seul', type: 'secteur', children: [] }
      ]);
    } else {
      return this.http.get<MDomain.IDomain[]>(
        `${this.communicationConfigService.getApiUri()}/domaine_formation/list/hierarchized`
      );
    }
  }
}
